module.exports = __webpack_public_path__ + "static/media/40s_models_temp.d23aa3b7.jpg";